import React from 'react';
import classNames from 'classnames';
import styles from './Spinner.module.scss';
/**
 * Faithful port of `Spinner` from `wix-ui-tpa/cssVars`.
 *
 * The `<svg>` is the root element, exactly as in WUT — no wrapper. Wrapping it in an inline-block
 * element puts it on the parent's text baseline and adds ~3px of descender space to the line box,
 * which grows every page that renders a spinner.
 *
 * The viewBox is fixed at 50 so the dash keyframes — which use absolute dash lengths, as
 * WUT's do — stay correct at any rendered diameter.
 *
 * stroke-dasharray is owned by CSS, not set as an SVG attribute, or the `dash` animation
 * would have nothing to animate against.
 */
const VIEWBOX = 50;
const RADIUS = 20;
const STROKE_WIDTH = 4;
export const Spinner = ({ className, diameter, isStatic = false, 'data-hook': dataHook, }) => (React.createElement("svg", { className: classNames(styles.root, { [styles.static]: isStatic }, className), viewBox: `0 0 ${VIEWBOX} ${VIEWBOX}`, style: diameter ? { width: `${diameter}px`, height: `${diameter}px` } : undefined, "data-hook": dataHook },
    React.createElement("circle", { className: styles.circle, cx: VIEWBOX / 2, cy: VIEWBOX / 2, r: RADIUS, fill: "none", strokeWidth: STROKE_WIDTH })));
//# sourceMappingURL=Spinner.js.map